import * as React from 'react';
import styled from 'styled-components';
import theme from 'theme';
import Logo from './Logo';
import LoginComponent from './LoginComponent';
import TietopalvelutNav from 'components/layout/navigation/top/TietopalvelutNav';
import { useAppContextOrThrow } from 'utils';

const Wrapper = styled.nav`
    height: ${theme.componentMeasures.topNavHeight};
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 4px solid ${theme.colors.main};
    border-bottom: 1px solid ${theme.colors.border_light_gray};
`;

export default function TopNavigation() {
    const context = useAppContextOrThrow();

    return (
        <Wrapper>
            <Logo />
            {context.state.auth.authenticated && <TietopalvelutNav />}
            <LoginComponent />
        </Wrapper>
    );
}
